import { unifiedDetermineArticleHeadingCount } from '@s1/core/utilities';
import toc from '../_toc';

const single = () => {
  toc();
  unifiedDetermineArticleHeadingCount();
};

window.addEventListener('DOMContentLoaded', () => {
  single();
});
